import { useState, useEffect } from "react";

export const useIsInitialRender = () => {
  const [isInitialRender, setIsInitialRender] = useState(true);

  useEffect(() => setIsInitialRender(false), []);

  return isInitialRender;
};
